import {
  getLoanApplicationById,
  getLoanById,
  getLoanStatusesByLoanId,
  getOrderStatusesByLoanId,
  patchProcessLoanApplicationInLenderManually,
} from '@nemuru-eng/js-api-client';

import { ApplicationTypeMap } from '@/config/maps/ApplicationType.map';
import { ApplicationType } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface UseLoanApplicationActionProps {
  loanId: string;
  loanApplicationId: string;
}

export const useChangeLenderApprovalStatus = ({ loanId, loanApplicationId }: UseLoanApplicationActionProps) => {
  const { request, loading } = useRequest();
  const { data: loan } = useCache(getLoanById, { loanId });
  const { revalidate: revalidateGetLoanApplication } = useCache(getLoanApplicationById, {
    loanApplicationId,
  });
  const { revalidate: revalidateLoanStatuses } = useCache(getLoanStatusesByLoanId, { loanId });
  const { revalidate: revalidateOrderStatuses } = useCache(getOrderStatusesByLoanId, { loanId });

  const applicationType = ApplicationTypeMap.fromAssetType(loan?.assetReference[0].type);

  const changeLenderApprovalStatus = async ({ lenderApprovalStatus }) => {
    await request(patchProcessLoanApplicationInLenderManually, {
      id: loanApplicationId,
      lenderApprovalStatus,
    });
    revalidateGetLoanApplication();
    revalidateLoanStatuses();
    applicationType === ApplicationType.ORDER && revalidateOrderStatuses();
  };

  return { loading, changeLenderApprovalStatus };
};
